import {
  getAppDataRequestError,
  getAppDataRequestMade,
  getAppDataRequestSuccess,
} from '../actionCreators/apiActions';

import { Action } from 'redux';
import { Auth } from '@justgiving/auth';
import { IAppState } from '../../types/state.d';
import { ThunkDispatch } from 'redux-thunk';
import fetchFundraisingPages from './fetchFundraisingPages';
import fetchTeamData from './fetchTeamData';

const fetchAppData = (teamGuid: string) => async (
  dispatch: ThunkDispatch<IAppState, Auth, Action>,
  getState: () => IAppState,
) => {
  try {
    const {
      router: {
        location: { pathname },
      },
    } = getState();

    const isJoin = new RegExp(/join/i).test(pathname);
    dispatch(getAppDataRequestMade());
    await dispatch(fetchTeamData(teamGuid));
    if (isJoin) {
      await dispatch(fetchFundraisingPages(teamGuid));
    }
    dispatch(getAppDataRequestSuccess());
  } catch (error) {
    dispatch(getAppDataRequestError((error as Error).message));
  }
};

export default fetchAppData;
